import {
  Avatar,
  Box,
  CircularProgress,
  IconButton,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import NorthStarCard from "./NorthStarCard";
import PulseStrip from "./PulseStrip";
import TableContainer from "../../Components/TableContainer";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import AxiosInstance from "../../Config/AxiosInstance";
import { ApiList } from "../../Config/ApiList";
import DummyUser from "../../Assets/User.webp";
import { Link, useNavigate } from "react-router-dom";
import totalUsers from "../../Assets/DashboardImages/TotalUsers.png";
import totalDogs from "../../Assets/DashboardImages/TotalDogs.png";
import { database } from "../../Config/firebase"; // Adjust the path based on your file structure
import { doc, getDoc, getFirestore, updateDoc } from "firebase/firestore";

const Dashboard = () => {
  const [loading, setLoading] = useState(true);
  const [userData, setUserData] = useState([]);
  const navigate = useNavigate();
  const getUserList = async (params) => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post(ApiList.USER_GET, params);
      if (response?.data?.s === 1) {
        const formattedUsers = response?.data?.r?.map((user, index) => ({
          rowid: index + 1,
          ...user,
        }));
        setUserData(formattedUsers);
        setLoading(false);
      } else {
        setUserData([]);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      setLoading(false);
    }
  };
  const fetchUserList = () => {
    const skip = 0;
    const total = `1`;
    const params = {
      select:
        "u.*,(SELECT COUNT(ud.id) FROM user_dogs AS ud WHERE ud.user_id = u.id AND ud.status = 1) AS total_dog",
      from: "users AS u",
      arg: "u.status = 1 AND u.role != 2",
      order: "u.id DESC",
      skip,
      limit: 10,
      total: total,
    };
    getUserList(params);
  };
  const columns = [
    {
      field: "rowid",
      headerName: "Sr.No",
      width: 80,
      align: "center",
      align: "center",
      headerAlign: "center",
    },
    {
      field: "image",
      headerName: "Profile",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => (
        <Avatar
          sx={{
            width: "40px",
            height: "40px",
            objectFit: "contain",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={
              params?.row?.image ? `${ApiList?.IMG_URL}${params?.row?.image}` : DummyUser
            }
            style={{ width: "100%", height: "100%" }}
          ></img>
        </Avatar>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const name = `${params?.row?.fname || ""} ${params?.row?.lname || ""}`;
        const truncatedCaption =
          name?.length > 20 ? `${name.substring(0, 20)}...` : name;
        return (
          <Tooltip title={`${params?.row?.fname} ${params?.row?.lname}`}>
            {truncatedCaption}
          </Tooltip>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const email = params.row.email;
        const truncatedCaption =
          email?.length > 20 ? `${email.substring(0, 20)}...` : email;
        return <Tooltip title={params?.row?.email}>{truncatedCaption}</Tooltip>;
      },
    },
    {
      field: "username",
      headerName: "User Name",
      flex: 1,
      minWidth: 200,
      headerClassName: "leftAlignHeader",
      cellClassName: "leftAlign",
      renderCell: (params) => {
        const userName = params?.row?.username;
        const truncatedCaption =
          userName?.length > 20 ? `${userName.substring(0, 20)}...` : userName;
        return (
          <Tooltip title={params?.row?.username}>{truncatedCaption}</Tooltip>
        );
      },
    },
    {
      field: "total_dog",
      headerName: "No. of Dogs",
      minWidth: 100,
      flex: 1,
    },
    {
      field: "Action",
      headerName: "Action",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            <IconButton
              onClick={() =>
                navigate("/user/user-profile", {
                  state: {
                    id: params?.row?.id,
                  },
                })
              }
            >
              <RemoveRedEyeIcon sx={{ color: "#b9cc03" }} />
            </IconButton>
          </Box>
        );
      },
    },
  ];
  const [totalUsersCount, setTotalUsersCount] = useState({});
  const getDahboardTotalCount = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.get(ApiList?.DASHBOARD_TOTAL_COUNTS);
      if (response?.data?.s === 1) {
        setTotalUsersCount(response?.data?.r);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUserList();
    getDahboardTotalCount();
  }, []);
  const label = { inputProps: { "aria-label": "Size switch demo" } };
  const [isUnderMaintenence, setIsUnderMaintenence] = useState(false);
  useEffect(() => {
    const fetchInitialState = async () => {
      try {
        const docRef = doc(database, "app_update", "app_update_treatwalk");
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // Set the state with the value from the Firestore document
          setIsUnderMaintenence(docSnap.data().under_maintenance);
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchInitialState();
  }, []); // Empty dependency array to fetch only once when component mounts
  const handleSwitchChange = async (event) => {
    const switchState = event.target.checked;
    setIsUnderMaintenence(switchState);
    const docRef = doc(database, "app_update", "app_update_treatwalk");
    try {
      await updateDoc(docRef, {
        under_maintenance: switchState,
      });
      console.log("Under maintenance updated successfully.");
    } catch (error) {
      console.error("Error updating under maintenance:", error);
    }
  };

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100vh",
          background: "#B9CC0310",
          overflow: "hidden",
        }}
      >
        <NorthStarCard />
        <PulseStrip />
        <Box
          sx={{
            width: "100%",
            p: 2,
            background: "#B9CC0310",
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "100%",
            justifyContent: "space-between",
            alignItems: { xs: "start", md: "center" },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "18px", md: "28px" },
              fontWeight: "300",
              color: "#000",
            }}
          >
            Dashboard
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography sx={{ color: "#000", fontWeight: "500" }}>
              Under Maintenance
            </Typography>
            <Switch
              {...label}
              color="warning"
              checked={isUnderMaintenence}
              onChange={handleSwitchChange}
            />
          </Box>
        </Box>
        <Box sx={{ width: "100%", height: "calc(100vh - 74px)", p: 2 }}>
          <Box sx={{ width: "100%", display: "flex", gap: "20px" }}>
            <Box
              sx={{
                width: { xs: "230px", xl: "350px" },
                borderRadius: "10px",
                display: "flex",
                justifyContent: "end",
                // background: "#C0FF00",
              }}
            >
              <Box
                sx={{
                  width: { xs: "225px", xl: "345px" },
                  borderRadius: "10px",
                  background: "#b9cc0360",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  p: 1,
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  

                  <Typography
                    sx={{
                      color: "#000",
                      fontWeight: "300",
                      fontSize: { xs: "16px", xl: "22px" },
                      // mt: "10px",
                      
                    }}
                  >
                    Total Registered Users
                  </Typography>
                </Box>

                {loading ? (
                  <CircularProgress sx={{ color: "#000" }} />
                ) : (
                  <Typography
                    sx={{
                      fontWeight: "600",
                      color: "#000",
                      fontSize: { xs: "30px", xl: "34px" },
                    }}
                  >
                    {totalUsersCount?.total_users}
                  </Typography>
                )}
              </Box>
            </Box>
            <Box
              sx={{
                width: { xs: "230px", xl: "350px" },
                borderRadius: "10px",
                display: "flex",
                justifyContent: "end",
 
              }}
            >
              <Box
                sx={{
                  width: { xs: "225px", xl: "345px" },
                  borderRadius: "10px",
                  background: "#b9cc0360",
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                  p: 1,
                }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  
                  <Typography
                    sx={{
                      color: "#000",
                      fontWeight: "300",
                      fontSize: { xs: "16px", xl: "22px" },
                    }}
                  >
                    Total Dogs
                  </Typography>
                </Box>
                {loading ? (
                  <CircularProgress sx={{ color: "#000" }} />
                ) : (
                  <Typography
                    sx={{
                      fontWeight: "600",
                      color: "#000",
                      fontSize: { xs: "30px", xl: "34px" },
                    }}
                  >
                    {totalUsersCount?.total_dogs}
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
          <Box
            sx={{
              width: "100%",
              justifyContent: "space-between",
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: "24px", xl: "28px" },
                color: "#000",
                fontWeight: "300",
                pt: 1,
              }}
            >
              Total Registered Users
            </Typography>
            <Link style={{ color: "#000" }} to={"/user"}>
              view all
            </Link>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: { xs: "calc(100vh - 265px)", xl: "calc(100vh - 300px)" },
              overflow: "scroll",
            }}
          >
            <TableContainer
              columns={columns}
              rows={userData}
              loading={loading}
              pagination={false}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Dashboard;
